











import { Component, Vue } from 'vue-property-decorator';
import Message from '@/common/components/Message.vue';
import Loader from '@/common/components/Loader.vue';
import { UserService, ConfirmationParamsInterface, SuccessResponseBodyInterface } from '@/common/services/user.service';
import { ErrorInterface } from '@/common/helpers/error.helper';
import { prepareRequestParams } from '@/common/helpers/prepare-request-data.helper';
import APP_CONFIG from '../config';
import { getText } from '@/common/locales';

@Component({
    components: {
        Message,
        Loader,
    },
})
export default class EmailActivation extends Vue {
    public messageTitle = '';
    public messageDescription = '';
    public isLoading = true;

    public mounted(): void {
        UserService.confirmEmailChange(this.confirmEmailChangeParams)
            .then(this.confirmEmailChangeSuccess)
            .catch(this.confirmEmailChangeError);
    }

    private get confirmEmailChangeParams(): ConfirmationParamsInterface {
        const { UAD_PORTAL, BASE_USER_AGENT } = APP_CONFIG;
        const params = {
            verificationCode: this.$route.params.token,
        };

        return prepareRequestParams(params, UAD_PORTAL, BASE_USER_AGENT) as ConfirmationParamsInterface;
    }

    private confirmEmailChangeSuccess(response: SuccessResponseBodyInterface): void {
        this.isLoading = false;
        this.messageTitle = getText('components.email_activation.email_changed');
    }

    private confirmEmailChangeError(error: ErrorInterface): void {
        this.isLoading = false;
        this.messageTitle = getText('components.email_activation.email_change_error');
        this.messageDescription = getText('components.email_activation.try_again');
    }
}
